// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*SCSS mixins for devices*/
/*Videos Tile container styles*/
.video__section {
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.video__section .VideoTile {
  margin: 0;
}

.video__container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 2rem;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.video__section--content {
  margin: 1rem;
}

@media only screen and (max-width: 600px) {
  .video__container {
    grid-template-columns: 1fr;
    padding: 1rem;
  }
  .video__container .content-container .content-headline {
    font-size: 2rem;
  }
}
/* These styles are for Text to motion tile*/
.text-to-motion-sample-slide {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 2rem;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.text-to-motion-sample-slide .image-container img {
  width: 100%;
}

.text-to-motion-sample-slide .content-container {
  width: 100%;
  align-items: flex-start;
  text-align: left;
}

.text-to-motion-sample-slide .content-container .content-headline {
  font-size: 3rem;
  align-items: flex-start;
}

.text-to-motion-sample-slide .content-container .content-description {
  align-items: flex-start;
  text-align: left;
}

@media only screen and (max-width: 600px) {
  .text-to-motion-sample-slide {
    grid-template-columns: 1fr;
    padding: 1rem;
  }
  .text-to-motion-sample-slide .content-container .content-headline {
    font-size: 2rem;
  }
}
/*These styles are for For Developer Tile set*/
.tile-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.tile-content .tile-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1.8rem;
}

.tile-content .tile-head i {
  font-size: 5rem;
}

.tile-content .tile-head div:last-child {
  font-size: 1rem;
}

.downArrow {
  font-size: 1.5rem;
  animation: bob 1s infinite;
}

@keyframes bob {
  0% {
    transform: translateY(-10px);
  }
  50% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(-10px);
  }
}`, "",{"version":3,"sources":["webpack://./src/_styles.scss","webpack://./src/components/Home.scss"],"names":[],"mappings":"AAAA,0BAAA;ACEA,+BAAA;AAEA;EACI,aAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AADJ;;AAIA;EACI,SAAA;AADJ;;AAIA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI;IACI,0BAAA;IACA,aAAA;EADN;EAIE;IACI,eAAA;EAFN;AACF;AAKA,4CAAA;AACA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAHJ;;AAMA;EACI,WAAA;AAHJ;;AAMA;EACI,WAAA;EACA,uBAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,uBAAA;AAHJ;;AAMA;EACI,uBAAA;EACA,gBAAA;AAHJ;;AAOA;EACI;IACI,0BAAA;IACA,aAAA;EAJN;EAOE;IACI,eAAA;EALN;AACF;AAQA,8CAAA;AAEA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAPJ;;AAUA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;AAPJ;;AAUA;EACI,eAAA;AAPJ;;AAUA;EACI,eAAA;AAPJ;;AAUA;EACI,iBAAA;EACA,0BAAA;AAPJ;;AAWA;EACI;IACI,4BAAA;EARN;EAWE;IACI,0BAAA;EATN;EAYE;IACI,4BAAA;EAVN;AACF","sourcesContent":["/*SCSS mixins for devices*/\n\n$mobile-max-width: 767px;\n\n@mixin mobile {\n  @media (max-width: $mobile-max-width) {\n    @content;\n  }\n}\n\n// Tablet screens (768px to 1024px)\n@mixin tablet {\n  @media (min-width: 768px) and (max-width: 1024px) {\n    @content;\n  }\n}\n\n// Desktop screens (1025px to 1439px)\n@mixin desktop {\n  @media (min-width: 1025px) and (max-width: 1439px) {\n    @content;\n  }\n}\n\n// Big monitor screens (1440px and up)\n@mixin big-monitor {\n  @media (min-width: 1440px) {\n    @content;\n  }\n}","@use '../styles';\n\n/*Videos Tile container styles*/\n\n.video__section {\n    display: flex;\n    gap: 1rem;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.video__section .VideoTile {\n    margin: 0;\n}\n\n.video__container {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 2rem;\n    padding: 2rem;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n}\n\n.video__section--content {\n    margin: 1rem;\n}\n\n@media only screen and (max-width: 600px) {\n    .video__container {\n        grid-template-columns: 1fr;\n        padding: 1rem;\n    }\n\n    .video__container .content-container .content-headline {\n        font-size: 2rem;\n    }\n}\n\n/* These styles are for Text to motion tile*/\n.text-to-motion-sample-slide {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 2rem;\n    padding: 2rem;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n}\n\n.text-to-motion-sample-slide .image-container img {\n    width: 100%;\n}\n\n.text-to-motion-sample-slide .content-container {\n    width: 100%;\n    align-items: flex-start;\n    text-align: left;\n}\n\n.text-to-motion-sample-slide .content-container .content-headline {\n    font-size: 3rem;\n    align-items: flex-start;\n}\n\n.text-to-motion-sample-slide .content-container .content-description {\n    align-items: flex-start;\n    text-align: left;\n}\n\n\n@media only screen and (max-width: 600px) {\n    .text-to-motion-sample-slide {\n        grid-template-columns: 1fr;\n        padding: 1rem;\n    }\n\n    .text-to-motion-sample-slide .content-container .content-headline {\n        font-size: 2rem;\n    }\n}\n\n/*These styles are for For Developer Tile set*/\n\n.tile-content {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n}\n\n.tile-content .tile-head {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: .5rem;\n    font-size: 1.8rem;\n}\n\n.tile-content .tile-head i {\n    font-size: 5rem;\n}\n\n.tile-content .tile-head div:last-child {\n    font-size: 1rem;\n}\n\n.downArrow {\n    font-size: 1.5rem;\n    animation: bob 1s infinite;\n}\n\n\n@keyframes bob {\n    0% {\n        transform: translateY(-10px);\n    }\n\n    50% {\n        transform: translateY(0px);\n    }\n\n    100% {\n        transform: translateY(-10px);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
